import type { Recipe } from '@domain/models/suggested-activities'

function normalizeCsvEntry(value: string): string {
  const trimmedStart = value.trimStart()
  if (trimmedStart.startsWith('and ')) {
    return trimmedStart.slice(4).trim()
  }
  return value.trim()
}

function parseFirestoreCsvList(value: unknown): string[] {
  if (typeof value !== 'string') {
    return []
  }

  return value
    .split(',')
    .map((item) => normalizeCsvEntry(item))
    .filter((item) => item.length > 0)
}

function asOptionalString(value: unknown): string | undefined {
  return typeof value === 'string' && value.trim().length > 0 ? value : undefined
}

export class RecipeConverter {
  public static fromFirestore(uid: string, data: Record<string, unknown>): Recipe {
    return {
      uid,
      title: typeof data.title === 'string' ? data.title : '',
      recipeMarkdownDescription:
        typeof data.recipe_markdown_description === 'string'
          ? data.recipe_markdown_description
          : '',
      length: asOptionalString(data.length),
      imageUrl: typeof data.image_url === 'string' ? data.image_url : '',
      mealTypes: parseFirestoreCsvList(data.meal_types),
      dietTypes: parseFirestoreCsvList(data.diet_types),
    }
  }

  public static toFirestore(recipe: Omit<Recipe, 'uid'>): Record<string, unknown> {
    return {
      title: recipe.title,
      recipe_markdown_description: recipe.recipeMarkdownDescription,
      length: recipe.length ?? null,
      image_url: recipe.imageUrl,
      meal_types: recipe.mealTypes.join(', '),
      diet_types: recipe.dietTypes.join(', '),
    }
  }
}
